import { EMAIL_TAGS } from "../../components/OneParkAdmin/emailTags";

export const TAG_REGEX = /(\{\{[A-Za-z]+\}\})/g;

export const findTagLabel = (tagValue) => {
  const tag = EMAIL_TAGS.find((t) => t.value === tagValue);
  return tag ? tag.label : tagValue.replace(/\{\{|\}\}/g, "");
};

export const buildChipHtml = (tagValue) => {
  const label = findTagLabel(tagValue);
  return `<span class="email-tag-chip" contenteditable="false" draggable="true" data-tag="${tagValue}">${label}<span class="email-tag-chip-delete" data-tag="${tagValue}">&times;</span></span>`;
};

export const valueToHtml = (value) => {
  if (!value) return "";
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(TAG_REGEX, (match) => buildChipHtml(match) + "\u200B")
    .replace(/\n/g, "<br>");
};

export const htmlToValue = (container) => {
  let result = "";
  const walk = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      result += node.textContent.replace(/\u200B/g, "");
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.classList && node.classList.contains("email-tag-chip")) {
        result += node.getAttribute("data-tag") || "";
        return;
      }
      if (node.tagName === "BR") {
        result += "\n";
        return;
      }
      if (node.tagName === "DIV" && result.length > 0 && !result.endsWith("\n")) {
        result += "\n";
      }
      for (const child of node.childNodes) {
        walk(child);
      }
    }
  };
  walk(container);
  return result;
};

export const placeCursorAtEnd = (element) => {
  const sel = window.getSelection();
  const range = document.createRange();
  range.selectNodeContents(element);
  range.collapse(false);
  sel.removeAllRanges();
  sel.addRange(range);
};

export const placeCursorAtNode = (node, container) => {
  const sel = window.getSelection();
  const range = document.createRange();
  if (node) {
    range.setStartBefore(node);
  } else {
    range.selectNodeContents(container);
    range.collapse(false);
  }
  range.collapse(true);
  sel.removeAllRanges();
  sel.addRange(range);
};

export const removeDuplicateChips = (container) => {
  const chips = container.querySelectorAll(".email-tag-chip");
  chips.forEach((chip) => {
    const next = chip.nextSibling;
    if (
      next &&
      next.nodeType === Node.ELEMENT_NODE &&
      next.classList &&
      next.classList.contains("email-tag-chip") &&
      next.getAttribute("data-tag") === chip.getAttribute("data-tag")
    ) {
      next.parentNode.removeChild(next);
    }
  });
};

export const insertLineBreak = () => {
  const sel = window.getSelection();
  if (sel.rangeCount === 0) return false;
  const range = sel.getRangeAt(0);
  range.deleteContents();
  const br = document.createElement("br");
  const textNode = document.createTextNode("\u200B");
  const frag = document.createDocumentFragment();
  frag.appendChild(br);
  frag.appendChild(textNode);
  range.insertNode(frag);
  const newRange = document.createRange();
  newRange.setStart(textNode, 1);
  newRange.collapse(true);
  sel.removeAllRanges();
  sel.addRange(newRange);
  return true;
};

const isChipNode = (node) =>
  node && node.nodeType === Node.ELEMENT_NODE && node.classList && node.classList.contains("email-tag-chip");

export const getAdjacentChip = (direction) => {
  const sel = window.getSelection();
  if (!sel.isCollapsed || sel.rangeCount === 0) return null;
  const range = sel.getRangeAt(0);

  if (direction === "before") {
    let node = null;
    if (range.startOffset > 0 && range.startContainer.nodeType === Node.ELEMENT_NODE) {
      node = range.startContainer.childNodes[range.startOffset - 1];
    } else if (range.startOffset === 0 && range.startContainer.nodeType === Node.TEXT_NODE) {
      node = range.startContainer.previousSibling;
    }
    return isChipNode(node) ? node : null;
  }

  let node = null;
  if (range.startContainer.nodeType === Node.ELEMENT_NODE) {
    node = range.startContainer.childNodes[range.startOffset];
  } else if (
    range.startContainer.nodeType === Node.TEXT_NODE &&
    range.startOffset === (range.startContainer.textContent || "").length
  ) {
    node = range.startContainer.nextSibling;
  }
  return isChipNode(node) ? node : null;
};

export const removeChipAndPlaceCursor = (node) => {
  const parent = node.parentNode;
  const nextSibling = node.nextSibling;
  parent.removeChild(node);
  placeCursorAtNode(nextSibling, parent);
};
